import { Component, Input } from '@angular/core';
import { Router } from '@angular/router';
import { ApiOffer, ApiOfferSet, ApiUser } from '@tytapp/api';

@Component({
  selector: 'tyt-classic-offers',
  templateUrl: './classic-offers.component.html',
  styleUrls: ['./classic-offers.component.scss']
})
export class ClassicOffersComponent {

  @Input()
  offerSet: ApiOfferSet;

  @Input()
  offersGroups: Array<any>;

  @Input()
  user: ApiUser;

  @Input()
  backgroundImage: string;

  headingCopy : string = 'Support TYT with a Membership.';
  subHeadingCopy : string = 'Memberships protect TYT\'s ability to report on the corruption in politics and mainstream media. We champion progressive issues important to ALL, not just the wealthy few. Members are critical to the sustainability of TYT.';
  subHeadingSecondCopy : string = '';

  constructor(private router: Router) { }

  offerPrice(offer : ApiOffer) {
    if (this.router.url.includes(offer.uuid)) {
      return offer.alternate_dollar_price;
    }
    return offer.dollar_price;
  }

  viewOfferText(offer: ApiOffer) {
    if (this.router.url.includes(offer.uuid)) {
      return 'View monthly option';
    }
    if (offer.alternate_membership_product.period === 'annually') {
      return 'View annual option';
    }
    return 'View other options';
  }

  async selectOfferTab(groupIndex: number, selected: number) {
    setTimeout(() => {
      this.offersGroups.forEach((offerGroup) => {
        if (offerGroup.groupIndex === groupIndex) {
          offerGroup.selected = selected;
        }
      })
    }, 1);
  }

  showAlternateOffer(alternateOfferId) {
    let url = '';
    if (this.router.url.includes(alternateOfferId)) {  // removing an offer id
      if (this.router.url.includes(`alternate-${alternateOfferId}-`)) {  // front of the pack with others behind
        url = this.router.url.replace(`-${alternateOfferId}`, '');
      } else if (this.router.url.includes(`alternate-${alternateOfferId}`)) {  // front of the pack solo
        url = this.router.url.replace(`alternate-${alternateOfferId}`, '');
      } else if (this.router.url.includes(`-${alternateOfferId}`)) { // middle of pack or last one
        url = this.router.url.replace(`-${alternateOfferId}`, '');
      }
    } else { // adding an offer id
      if (this.router.url.includes('alternate')) { // an offer id is already there
        url = `${this.router.url}-${alternateOfferId}`
      } else {
        url = `${this.router.url}/alternate-${alternateOfferId}`
      }
    }

    return url;

    // this.redirection.go(url);

  }

}
